import {Component} from '@angular/core';

@Component({
    selector: 'landing-ad-hero',
    templateUrl: './landing-ad-hero.component.html',
    standalone: false
})
export class LandingAdHeroComponent {
}
